module.exports = __webpack_public_path__ + "static/img-56fcf0e1b11c81d2b24752b4f05ac8f3.jpeg";